import '../scss/style.scss'
import animations from './modules/animations'

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('load', () => animations.intro())
})
